import { ModalTypes, useModalContext } from 'application/providers/ModalProvider';
import {
  selectIsAcceptanceAdvancedSigningLoading,
  selectAcceptanceAdvancedContext,
  startAcceptanceAdvancedSigning,
  openSigningPreloadTab,
} from 'application/store';
import { useAppDispatch, useAppSelector } from 'application/providers/StoreProvider';
import { DEFAULT_ACCEPTANCE_ADVANCED_ID } from 'application/store/slices/acceptanceAdvancedSlice/consts';

import { SBBOL_URI_FOR_RETURN } from './sbbolReturnUri';

interface UseStartAcceptanceAdvancedSigning {
  startSigningAcceptanceAdvancedLoading: boolean;
  startSigningAcceptanceAdvanced: (companyId: string) => void;
}

export const useStartAcceptanceAdvancedSigning = (): UseStartAcceptanceAdvancedSigning => {
  const { openModal } = useModalContext();
  const dispatch = useAppDispatch();

  const startSigningAcceptanceAdvancedLoading = useAppSelector(selectIsAcceptanceAdvancedSigningLoading());
  const acceptanceAdvancedContext = useAppSelector(selectAcceptanceAdvancedContext(DEFAULT_ACCEPTANCE_ADVANCED_ID));

  const startSigningAcceptanceAdvanced = (companyId: string) => {
    const hasActiveTab = acceptanceAdvancedContext?.hasActiveTab;
    const preOpenedTab = hasActiveTab ? null : openSigningPreloadTab();

    dispatch(
      startAcceptanceAdvancedSigning({
        companyId,
        uriForReturn: SBBOL_URI_FOR_RETURN,
        fallbackFn: () => {
          openModal(ModalTypes.SBERBUSSINESS_OPEN, {});
        },
        preOpenedTab,
      })
    );
  };

  return { startSigningAcceptanceAdvancedLoading, startSigningAcceptanceAdvanced };
};
